var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcodeMatchRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.87
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1.919V23.395H0zM3.838 0H7.676V23.395H3.838zM9.596 0H11.515V23.395H9.596zM15.353 0H17.272V23.395H15.353zM21.11 0H23.029V23.395H21.11zM24.949 0H26.868000000000002V23.395H24.949z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.515 7.798)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.596,
    cy: 9.748,
    fill: "#FFF",
    rx: 9.596,
    ry: 9.748
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB3C39",
    d: "M9.596 0c1.753 0 3.375.445 4.867 1.336 1.445.843 2.583 2 3.413 3.468.877 1.515 1.315 3.163 1.315 4.944 0 1.78-.438 3.429-1.315 4.944-.83 1.469-1.968 2.625-3.413 3.468-1.492.89-3.114 1.336-4.867 1.336-1.753 0-3.376-.445-4.867-1.336-1.446-.859-2.584-2.023-3.414-3.491C.438 13.153 0 11.513 0 9.748c0-1.765.438-3.406 1.315-4.92.846-1.47 1.991-2.633 3.437-3.492C6.243.446 7.858 0 9.596 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.926 6.033L10.846 10.113 14.926 14.193 13.889 15.231 9.809 11.151 5.729 15.231 4.691 14.193 8.771 10.113 4.691 6.033 5.729 4.996 9.809 9.076 13.889 4.996z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeMatchRed);
export default __webpack_public_path__ + "static/media/barcode_match_red.e4551bf13cc55550ac35ce525d10eb1d.svg";
export { ForwardRef as ReactComponent };